import Service, { getCallApiFunction } from '../service'
import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  pageSize: number
  pageNo: number
}

class FetchThemeProductListApi extends Service {
  constructor(themeId: string, params: ParamsType) {
    super()
    this.name = 'FETCH_THEME_PRODUCT_LIST'

    this.config = {
      url: `/v1/product/theme-halls/${themeId}`,
      method: 'GET',
      params,
    }

    this.denormalizer = denormalizer
  }
}

export const fetchThemeProductList = (themeId: string, params: ParamsType) => getCallApiFunction(new FetchThemeProductListApi(themeId, params))
